export default __webpack_public_path__ + "static/media/640_business02-it-web.050bb464.png";